import './styles/index.scss';
import {AppMainContainer} from "./components/AppMainContainer";
import {Providers} from "./components/Providers";

function App() {

    return (
        <Providers>
            <AppMainContainer/>
        </Providers>
    );
}

export default App;
